import { Reveal, ChapterLabel } from "./Reveal";
import { site } from "../content";

export const About = () => {
  const { about } = site;
  return (
    <section id="minusta" className="py-24 md:py-32 bg-[#FBF8F4]" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-14 lg:gap-20 items-center">
        <Reveal className="lg:col-span-5">
          <div
            className="grain aspect-[3/4] rounded-[2rem] overflow-hidden bg-[#EFE6DC] shadow-[0_24px_60px_rgba(43,39,36,0.08)] relative max-w-sm"
            data-testid="about-image"
          >
            <img
              src="/images/milja-about.jpg"
              alt={about.imageAlt}
              width={471}
              height={628}
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <ChapterLabel chapter={about.chapter} label={about.label} />
            <h2 className="mt-5 font-serif font-light text-3xl md:text-5xl tracking-tight text-[#2B2724]">
              {about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <blockquote className="mt-10 border-l-2 border-[#7C8C7E] pl-6 font-serif italic text-xl md:text-2xl text-[#4A6572] leading-relaxed">
              {about.quote}
            </blockquote>
          </Reveal>
          <Reveal delay={0.15}>
            <div className="mt-8 space-y-5 text-base md:text-lg leading-relaxed text-[#5C564F]">
              {about.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>
            <p className="mt-10 font-serif italic text-4xl text-[#7C8C7E]" data-testid="about-signature">
              {about.signature}
            </p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
